import styled from 'styled-components';
export const PriceSelectContainer = styled.div `
  padding: 10px;
  ${props => props.theme.mixins.mobile('padding: 10px 0;')};
`;
export const SliderWrapper = styled.div `
  padding-top: 10px;
  ${props => props.theme.mixins.mobile(`
    width: 470px;
    padding-top: 20px;
  `)};
  @media (max-width: 550px) { width: 100%; }
`;
